export default __webpack_public_path__ + "static/media/YAS0580.34I-30576_-17592_0.225ae236.jpg";